import { setContext } from "@apollo/client/link/context";
import { getMainDefinition } from "@apollo/client/utilities";

// Must match Common.Backend.Utils.ChangeSetHeader. Only groups asset history rows for display.
export const CHANGE_SET_HEADER = "X-Change-Set-Id";

let activeChangeSetId: string | null = null;

/** Starts a new change set; every mutation until `endChangeSet` is grouped into one asset history entry. */
export const startChangeSet = (): string | null => {
  // Without a secure random generator the server creates one group per request.
  activeChangeSetId = typeof crypto?.randomUUID === "function" ? crypto.randomUUID() : null;
  return activeChangeSetId;
};

/** Ends the given change set; a newer one that was started meanwhile stays active. */
export const endChangeSet = (id: string | null | undefined) => {
  if (id && activeChangeSetId === id) activeChangeSetId = null;
};

export const changeSetLink = setContext((operation, { headers }) => {
  if (!activeChangeSetId) return {};
  const definition = getMainDefinition(operation.query);
  if (definition.kind !== "OperationDefinition" || definition.operation !== "mutation") return {};
  return { headers: { ...headers, [CHANGE_SET_HEADER]: activeChangeSetId } };
});
